import { useNotify, useRedirect } from 'react-admin'
import CurveCreateForm from '../../Components/Curves/CurveCreateForm'

const Create = () => {
  const notify = useNotify()
  const redirect = useRedirect()
  const entrypoint = process.env.REACT_APP_API_PLATFORM_ENDPOINT

  const handleSave = async (payload) => {
    try {
      const response = await fetch(`${entrypoint}/services/curve/create/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })

      if (!response.ok) throw new Error('Failed to create curve')

      notify('Curve created', { type: 'success' })
      redirect('list', 'curves')
    } catch (e) {
      notify(`Error: ${e.message}`, { type: 'error' })
    }
  }

  return <CurveCreateForm onSubmit={handleSave} />
}

export default Create
